import { getToday } from "../utils";
import { diasEntre, somarDias } from "./abordagem";

// ═══════════════════════════════════════════════════════════════
// RÉGUA DE SATISFAÇÃO — de 3 em 3 meses, sem depender de memória
// ═══════════════════════════════════════════════════════════════
//
// Parceiro ativo sai do radar: ninguém liga para quem não está dando
// problema, e a primeira notícia de que ele estava insatisfeito costuma ser a
// saída dele da rede. A régua existe para essa conversa acontecer antes.
//
// Só entram parceiros ATIVOS. Cobrar pesquisa de quem ainda está em abordagem
// seria perguntar a opinião de quem nunca foi atendido.

export const CICLO_DIAS = 90;

/** A última pesquisa respondida por esta empresa. */
export function ultimaPesquisa(pesquisas = [], parceiro = {}) {
  const cnpj = String(parceiro.cnpj || "").replace(/\D/g, "");
  const minhas = (pesquisas || []).filter((p) => {
    if (p?.partnerId && p.partnerId === parceiro.id) return true;
    if (p?.clientId && p.clientId === parceiro.id) return true;
    const dela = String(p?.meta?.cnpj || "").replace(/\D/g, "");
    return !!cnpj && dela === cnpj;
  });
  if (!minhas.length) return null;
  return minhas
    .slice()
    .sort((a, b) => String(a.surveyDate || a.createdAt || "").localeCompare(String(b.surveyDate || b.createdAt || "")))
    .pop();
}

/**
 * Quem está devendo pesquisa: parceiro ativo que nunca respondeu, ou cuja
 * última resposta passou do ciclo. Nunca respondeu conta a partir da data em
 * que ele virou ativo — não faz sentido cobrar pesquisa de quem ativou ontem.
 */
export function devidos(partners = [], pesquisas = [], hoje = getToday()) {
  const lista = [];
  for (const p of partners || []) {
    if (p.stage !== "ativo") continue;
    const ultima = ultimaPesquisa(pesquisas, p);
    const dataBase = ultima?.surveyDate || ultima?.createdAt || virouAtivoEm(p) || p.createdAt;
    if (!dataBase) continue;
    const dias = diasEntre(String(dataBase).slice(0, 10), hoje);
    if (dias >= CICLO_DIAS) {
      lista.push({
        parceiro: p,
        ultima: ultima || null,
        desde: String(dataBase).slice(0, 10),
        dias,
        nota: ultima?.score ?? null,
        proxima: somarDias(String(dataBase).slice(0, 10), CICLO_DIAS),
      });
    }
  }
  return lista.sort((a, b) => b.dias - a.dias);
}

/** A data em que o parceiro entrou em "ativo", lida da trilha. */
export function virouAtivoEm(parceiro = {}) {
  const evento = (Array.isArray(parceiro.stageHistory) ? parceiro.stageHistory : [])
    .filter((h) => h?.to === "ativo")
    .pop();
  return evento?.date || null;
}

/** Resumo para o banner: quantos, e o pior caso. */
export function resumoDevidos(partners, pesquisas, hoje = getToday()) {
  const lista = devidos(partners, pesquisas, hoje);
  const nunca = lista.filter((d) => !d.ultima).length;
  return {
    total: lista.length,
    nunca,
    maisAntigo: lista[0] || null,
    lista,
  };
}
